/**
 * Gemeinsame Overlay-Styles und Fehleranzeige für Hub-Tabs.
 */
export const LOADING_STYLE =
  'color:#4a6a7a;padding:clamp(20px,5vw,40px);text-align:center;' +
  'font-size:clamp(13px,2.8vw,14px);letter-spacing:1px;';

export const ERROR_STYLE =
  'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);z-index:99999;' +
  'background:rgba(0,0,0,0.75);backdrop-filter:blur(4px);' +
  'padding:clamp(10px,2vw,16px) clamp(18px,3.5vw,32px);border-radius:8px;' +
  'border:1px solid rgba(255,100,100,0.3);' +
  'color:#f66;font-family:monospace;font-size:clamp(13px,2.8vw,14px);pointer-events:none;';

export function showHubError(msg: string): void {
  const el = document.createElement('div');
  el.style.cssText = ERROR_STYLE;
  el.textContent = msg;
  document.body.appendChild(el);
  setTimeout(() => el.remove(), 2000);
}
